export default __webpack_public_path__ + "static/image3-ac07bfe09ac4316b8d8ea782db96f925.jpeg";